import type { CompRef } from '@wix/document-services-types';
import type { WixComponentManifest } from '@wix/component-protocol/schema';

export enum ManifestDefinitions {
  behaviors = 'editingBehaviors',
  style = 'style',
  rootManifestData = 'rootManifestData',
  compType = 'compType',
}

export type Store = {
  [key: string]: WixComponentManifest;
};

export type EditorPointer = {
  compRef: CompRef; // top level comp ref
  innerElementPath?: string[]; // inner element path. Example: [widget1, box1]
};

export interface InnerElementsHierarchyStructure {
  key: string;
  innerElements?: InnerElementsHierarchyStructure[];
  selector: string;
}

export type InnerElementsPathsBuilderStructures = {
  compPointer: CompRef;
  innerElements: InnerElementsHierarchyStructure[];
}[];
